import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Form, Nav, Tab, Table } from "react-bootstrap";
import swal from "sweetalert";
import "@fortawesome/fontawesome-free/css/all.min.css";

import OldAddExpenses from "../OldNewExpenses/OldAddExpenses";
import NewAddExpenses from "../OldNewExpenses/NewAddExpenses";
import NewAddedstyleExpenses from "../OldNewExpenses/NewAddedstyleExpenses";

const AddExpenses = (authrztn) => {
  const [selectedValue, setSelectedValue] = useState("NEWSTYLE");
  return (
    <div className="h-100 w-100 border bg-white custom-container">
      {selectedValue === "OLD" ? (
        <OldAddExpenses authrztn={authrztn} />
      ) : selectedValue === "NEW" ? (
        <NewAddExpenses authrztn={authrztn} />
      ) : selectedValue === "NEWSTYLE" ? (
        <NewAddedstyleExpenses authrztn={authrztn} />
      ) : null}
    </div>
  );
};

export default AddExpenses;
